export default "__VITE_ASSET__BfHYzlph__"